import { tables } from "./tables";
import { stoyki_podkatnie } from "./stoyki_podkatnie";
import { stoli_podkatnie } from "./stoli_podkatnie";
import { telezhki } from "./telezhki";
import { tumbi } from "./tumbi";
import { stellazhi } from "./stellazhi";
import { stulya } from "./stulya";
import { verstaki } from "./verstaki";
import { wardrobes } from "./wardrobes";

// 1. Здесь перечисляем все наборы карточек товаров.
//    Ключ объекта — имя папки/каталога (folderName).
//    Значение — объект с ключами-массивами карточек (например metall_type, construct_type).
//    Чтобы добавить новый набор — импортируй и допиши сюда.
const sources = {
    tables,
    stoyki_podkatnie,
    stoli_podkatnie,
    telezhki,
    tumbi,
    stellazhi,
    stulya,
    verstaki,
    wardrobes,
};

// 2. Формируем итоговый объект cardItems.
//    Для каждой карточки автоматически добавляем два свойства:
//    - folderName — откуда импортирована карточка (например "tables").
//    - typeName — из какого массива внутри набора карточка (например "metall_type").
export const cardItems = Object.fromEntries(
    // Преобразуем sources из объекта в массив пар [folderName, data]
    Object.entries(sources).map(([folderName, data]) => [
        // Ключ итогового объекта cardItems — имя набора (например "tables")
        folderName,

        // Значение — новый объект, где каждый ключ соответствует массиву карточек с добавленными свойствами
        Object.fromEntries(
            // Пробегаем по ключам объекта data (например metall_type, construct_type)
            Object.entries(data).map(([typeName, arr]) => [
                // Ключ без изменений (например "metall_type")
                typeName,

                // Если значение — массив карточек, добавляем к каждой карточке folderName и typeName
                Array.isArray(arr)
                    ? arr.map((item) => ({
                          ...item,
                          folderName, // Источник карточки, например "tables"
                          typeName, // Тип карточки, например "metall_type"
                      }))
                    : // Если значение не массив — оставляем без изменений (например пустой объект или другое значение)
                      arr,
            ]),
        ),
    ]),
);

window.cardItems = cardItems;
